import { render, staticRenderFns } from "./addRevenue.vue?vue&type=template&id=0a22eca4&scoped=true&"
import script from "./addRevenue.vue?vue&type=script&lang=js&"
export * from "./addRevenue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a22eca4",
  null
  
)

export default component.exports